import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Input,
  InputNumber,
  Select,
  Switch,
  Upload,
  Button,
  Badge,
  message,
  Tooltip,
  DatePicker,
  Checkbox
} from "antd";
import { Form, Icon } from "@ant-design/compatible";
import AddCategoryModal from "../AddCategoryModal";
import moment from "moment";
import { VariantKeySelector, VariantValueSelector } from "../../../../../../components/VariantSelector";
import { getVariantPresetByBusinessTypeString, VARIANT_PRESETS } from "../../../../../../constants/variantPresets";
// Redux
import { connect } from "react-redux";
import { getAllCategories } from "../../../../../../redux/actions/categoryActions";
import { getAllLoyaltyPrograms } from "../../../../../../redux/actions/loyaltyActions";
import {
    addNewProduct,
  getAllProducts,
} from "../../../../../../redux/actions/productActions";
import validateVariant from "../../../../../../utils/validateVariant";
import { transformInToFormObject } from "../../../../../../utils/generateFormData";
import api from "../../../../../../api";
import ValidateCustomQuantity from "../../../../../../utils/validateCustomQuantity";
// UI
import "./index.scss";
import strings from "../../../../../../strings";

const FormItem = Form.Item,
  Option = Select.Option;

const config = {
  bucketName: "loystar-android",
  region: "us-east-1",
  accessKeyId: "AKIAWOIS4FL7KHGYG6BT",
  secretAccessKey: "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",
};

const maxFileSize = 4000000;

// Image Upload URL
const url = "https://api.cloudinary.com/v1_1/loystar/image/upload";

const CloneProductModal = Form.create()(
  class extends Component {
    static propTypes = {
      user: PropTypes.object.isRequired,
      showModal: PropTypes.bool.isRequired,
      closeModal: PropTypes.func.isRequired,
      allLoyaltyPrograms: PropTypes.arrayOf(PropTypes.object).isRequired,
      allCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
      getAllCategories: PropTypes.func.isRequired,
      getAllLoyaltyPrograms: PropTypes.func.isRequired,
      getAllProducts: PropTypes.func.isRequired,
      addNewProduct: PropTypes.func.isRequired,
    };

    state = {
      isAddNewCategory: false,
      showTaxedSelect: false,
      isTrackProduct: false,
      hasVariant: false,
      fileList: [],
      loading: false,
      showAddCategoryModal: false,
      variants: [],
      imageLoading: false,
      imageUploadError: false,
      imageUploadSuccess: false,
      hasCustomQuantity: false,
      customQuantity: [],
      shouldProductBePublished: true,
      editingVariant: null,
      editingVariantIndex: null
    };

    componentDidMount() {
      const { form, product } = this.props;
      this.props.getAllCategories();
      this.props.getAllLoyaltyPrograms();

      if (!product) {
        return;
      }

      this.setState({ 
        showTaxedSelect: product.tax, 
        shouldProductBePublished: product.publish_to_loystar_shop,
        hasVariant: product.variants && product.variants.length > 0 ? true : false, 
        variants: product.variants && product.variants.length > 0 ? [...product.variants] : [],
        hasCustomQuantity: product.custom_quantities && product.custom_quantities.length > 0 ? true : false,
        customQuantity: product.custom_quantities && product.custom_quantities.length > 0 ? [...product.custom_quantities] : [],
      });

      this.setState({ isTrackProduct: product.track_inventory || false }, () =>{
        form.setFieldsValue({ 
            ...product,
            low_stock_notification: false,
            isProductExpire: false,
            product_variants: product.variants && product.variants.length > 0 ? true : false, 
            has_custom_qty: product.custom_quantities && product.custom_quantities.length > 0 ? true : false,
        })
    });
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.error) {
        this.setState({ loading: false });
      }
    }

    onCategoryChange = value => {
      if (value === "add-new-category") {
        this.toggleAddCategoryModal();
      }
    };

    onLoyaltyProgramChange = value => {
      if (value === null) {
        this.props.toggleAddLoyaltyModal();
      }
    };

    handleTaxProduct = value => {
      this.setState({ showTaxedSelect: value });
      this.props.form.setFieldsValue({ tax: value });
    };

    handlePublishProduct = (value) => {
      this.setState({ shouldProductBePublished: value });
      this.props.form.setFieldsValue({ publish_to_loystar_shop: value });
    };

    handleLowStockNotification = value => {
      this.setState({ showLowStockNotification: value });
      this.props.form.setFieldsValue({ lowStockNotification: value });
    };

    handleTrackProduct = value => {
      if (this.state.hasVariant) {
        message.warn(strings.productVariantsRequireTracking);
      }

      this.setState({ isTrackProduct: value });
      this.props.form.setFieldsValue({ track_inventory: value });
    };

    handleProductVariants = value => {
      const { hasCustomQuantity } = this.state;
      if(hasCustomQuantity){
        return Modal.info({
          title: "Cannot add variants to product with custom quantity"
        })
      }else{
        this.setState({ hasVariant: value, isTrackProduct: value });
        this.props.form.setFieldsValue({
          product_variants: value,
          track_inventory: value,
        });
      }

      
    };

    handleProductCustom = value => {
      const { hasVariant } = this.state;

      if(hasVariant){
        return Modal.info({
          title: "Cannot add custom quantity to product with variant"
        })
      }

      this.setState({ hasCustomQuantity: value, isTrackProduct: value });
      this.props.form.setFieldsValue({
        has_custom_qty: value,
        track_inventory: value
      });
    }

    /**
     * Get the appropriate variant preset key based on user's business type
     */
    getVariantPresetKey = () => {
      const { user } = this.props;
      if (user && user.business_type) {
        const preset = getVariantPresetByBusinessTypeString(user.business_type);
        // Find the key that maps to this preset label
        const presetKey = Object.keys(VARIANT_PRESETS).find(
          key => VARIANT_PRESETS[key].label === preset.label
        );
        return presetKey || 'GENERAL';
      }
      return 'GENERAL';
    }

    addVariant = () => {
      const { form } = this.props;
      const { variants, editingVariant, editingVariantIndex } = this.state;
      form.validateFields((err, values) => {
        const {
          variant_type,
          variant_value,
          variant_price,
          variant_cost_price,
          variant_quantity,
        } = values;

        const result = validateVariant(
          variant_price,
          // variant_cost_price,
          variant_type,
          variant_value,
          variant_quantity
        );

        if (!result.status) {
          Modal.warning({
            title: validateVariant(
              variant_price,
              // variant_cost_price,
              variant_type,
              variant_value,
              variant_quantity
            ).message,
          });
          return;
        }

        // Check for duplicate variants (excluding the one being edited)
        const isAdded = variants.find((variant, index) => {
          return variant.value.toLowerCase() === variant_value.toLowerCase() && index !== editingVariantIndex;
        });
        if (isAdded) {
          Modal.warning({
            title: strings.suchVariantAlreadyExist,
          });
        } else {
          // Handle Update
          if (editingVariant !== null && editingVariantIndex !== null) {
            const updatedVariants = [...variants];
            updatedVariants[editingVariantIndex] = {
              value: variant_value,
              type: variant_type,
              price: variant_price,
              cost_price: variant_cost_price,
              quantity: variant_quantity
            };
            
            this.setState({
              variants: updatedVariants,
              editingVariant: null,
              editingVariantIndex: null
            });

            // Update Product Quantity to Total Quantity of Variants
            const totalVariantQty = updatedVariants.reduce(
              (total, variant) => total + Number(variant.quantity),
              0
            );

            totalVariantQty > 0 &&
              this.props.form.setFieldsValue({ quantity: totalVariantQty, variant_value: "", variant_type: "" });
            message.success("Variant updated successfully!");
          } else {
            // Handle Add
            this.setState({
              variants: [
                ...variants,
                {
                  value: variant_value,
                  type: variant_type,
                  price: variant_price,
                  cost_price: variant_cost_price,
                  quantity: variant_quantity,
                },
              ],
            });

            // Update Product Quantity to Total Quantity of Variants
            let variantsCopy = [
              ...variants,
              {
                value: variant_value,
                type: variant_type,
                price: variant_price,
                cost_price: variant_cost_price,
                quantity: variant_quantity,
              },
            ];

            const totalVariantQty =
              variantsCopy.length &&
              variantsCopy.reduce(
                (total, variant) => total + Number(variant.quantity),
                0
              );

            totalVariantQty > 0 &&
              this.props.form.setFieldsValue({ quantity: totalVariantQty });
          }
        }
      });
    };

    handleEditVariant = (variant, index) => {
      const { form } = this.props;
      this.setState({
        editingVariant: variant,
        editingVariantIndex: index
      });
      
      // Pre-populate form fields with variant data
      form.setFieldsValue({
        variant_type: variant.type,
        variant_value: variant.value,
        variant_price: variant.price,
        variant_cost_price: variant.cost_price,
        variant_quantity: variant.quantity
      });

      // Scroll to form for better UX
      setTimeout(() => {
        const formElement = document.querySelector('[data-variant-form]');
        if (formElement) {
          formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);
    };

    handleCancelEditVariant = () => {
      const { form } = this.props;
      this.setState({
        editingVariant: null,
        editingVariantIndex: null
      });
      
      // Clear form fields
      form.setFieldsValue({
        variant_type: "",
        variant_value: "",
        variant_price: undefined,
        variant_cost_price: undefined,
        variant_quantity: undefined
      });
    };

    handleRemoveCustomQty =(value) => {
      const { customQuantity } = this.state;
      const result = customQuantity.filter(custQty => {
        return custQty.name !== value.name;
      });
      this.setState({
        customQuantity: result,
      });
    };

    displayCustomQuantity = () => {
      const { customQuantity } = this.state;

      if (customQuantity.length === 0) return strings.addCustom + "...";
      return customQuantity.map((custQty, key) => {
        const { name, price, quantity, id } = custQty;
        return (
          <li>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", margin: "0 30% 0 0"}}>
              <span>{name} ({quantity} units) - {price}</span>
              <div style={{display: "flex", alignItems: "center", gap: "0.5rem", margin: "0"}}>
                {/* <Icon type="edit"  onClick={()=>this.handleEditCustom(custQty)}/> */}
                <Icon type="delete"onClick={() => {this.handleRemoveCustomQty(custQty);}}/>
              </div>
            </div>
          </li>
          // <Badge
          //   key={key}
          //   count={custQty.quantity}
          //   style={{
          //     backgroundColor: "#D90068",
          //     color: "#fffff",
          //     marginBottom: "10px",
          //   }}
          // >
          //   <Tooltip title={`${strings.costPrice}:- ${custQty.name}`}>
          //     <div className="variant">
          //       <span>{custQty.name}</span>-
          //       <span>{custQty.price ? `#${custQty.price}` : null}</span>
          //       <span
          //         className="btn delete-variant-btn"
          //         onClick={() => {
          //           this.handleRemoveCustomQty(custQty.value);
          //         }}
          //       >
          //         x
          //       </span>
          //     </div>
          //   </Tooltip>
          // </Badge>
        );
      });
    };

    uploadProps = {
      name: "file",
      action: url,
      headers: {
        body: JSON.stringify({ upload_preset: "hyemnes2", folder: "test_img" }),
      },
      onChange(info) {
        if (info.file.status === "done") {
          message.success(`${info.file.name} ${strings.fileUploadSuccessful}`);
          // setstate({ ...state, imageUrl: info.file.response.imageCloudData.url });
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} ${strings.fileUploadFailed}`);
        }
      },
    };
    handleExpiryDate = value => {
      this.setState({ isProductExpire: value });
    };

    handleDatepicker = (d, datestring, name) => {
      let timestamp = moment(datestring).format("YYYY-MM-DD hh:mm:ss");

      const value = moment.utc(timestamp).format();
      this.setState({ [name]: value });
    };

    addCustomQuantity = () => {
      const { form } = this.props;
      const { customQuantity } = this.state;
     
      form.validateFields(async (err, values) => {
        const {
          custom_name,
          custom_price,
          barcode,
          custom_quantity
        } = values;
        
        const result = ValidateCustomQuantity(
          custom_name,
          custom_price,
          barcode,
          custom_quantity
        );

        if (!result.status) {
          Modal.warning({
            title: ValidateCustomQuantity(
              custom_name,
              custom_price,
              barcode,
              custom_quantity,
            ).message,
          });
          return;
        }

        if(custom_name === "" || custom_quantity === "" || custom_price === ""){
          return Modal.warning({
            title: "Please input custom properties to add",
          });
        }
        const isAdded = customQuantity.find((custName) => {
          return custName.name.toLowerCase() === custom_name.toLowerCase();
        });

        if (isAdded) {
          Modal.warning({
            title: strings.suchUnitAlreadyExist,
          });
        } else {
          this.setState({
            customQuantity: [
              ...customQuantity,
              {
                barcode: barcode,
                // product_id: product.id,
                // merchant_id: product.merchant_id,
                price: custom_price,
                name: custom_name,
                quantity: custom_quantity,
              },
            ]
          });
          
          // Update Product Quantity to Total Quantity of Variants

          let customQuantityCopy = [
            ...customQuantity,
            {
              barcode: barcode,
              // product_id: product.id,
              // merchant_id: product.merchant_id,
              price: custom_price,
              name: custom_name,
              quantity: custom_quantity,
            },
          ];

          const totalCustomQuantity =
          customQuantityCopy.length &&
          customQuantityCopy.reduce(
              (total, custom) => total + Number(custom.quantity),
              0
            );

          // totalVariantQty > 0 &&
          //   this.props.form.setFieldsValue({ quantity: totalVariantQty });
        }
      });
    };

    handleAddProduct = () => {
      const { 
        form, 
        getAllProducts, 
        addNewProduct, 
        product 
    } = this.props;

      const {
        hasVariant,
        variants,
        fileList,
        isProductExpire,
        s_expiry_date,
        s_start_expiration_notification,
        showLowStockNotification,
        hasCustomQuantity,
        shouldProductBePublished
      } = this.state;

      form.validateFields((err, values) => {
        if (err || (hasVariant && variants.length === 0)) {

          if (hasVariant && variants.length === 0) {
            Modal.warning({
              title: strings.pleaseAddVariantClickButton,
            });
          }
          return message.error("Please fill all required fields!");
        }

        const variantTotal = variants.reduce(
          (total, variant) => total + Number(variant.quantity),
          0
        );

        if (err || variantTotal > Number(values.quantity)) {
          Modal.warning({
            title: strings.totalVariantsMoreThanSelectedQuantity,
          });
          return;
        }

        if(product.name === values.name){
            return Modal.warning({
                title: strings.productWithSameName
            })
        }

        this.setState({ loading: true });

        if (hasVariant) {
          delete values.variant_type;
          delete values.variant_value;
          delete values.variant_price;
          delete values.variant_cost_price;
          delete values.variant_quantity;
          values.variants = variants.map(variant => {
            let obj = {};

            for (let key in variant) {
              if (variant[key]) {
                obj[key] = variant[key];
              }
            }

            return obj;
          });
        }

        delete values.picture;

        let payload = {
          quantity: values.quantity ? Number(values.quantity) : 0,
          price: values.price && Number(values.price).toFixed(2),
          publish_to_loystar_shop: shouldProductBePublished,
          product_sku: values.product_sku || "",
          isProductExpire: isProductExpire,
        };

        if (values.cost_price) {
          payload.cost_price =
            values.cost_price && Number(values.cost_price).toFixed(2);
        }

        if (values.tax_rate) {
          payload.tax_rate = Number(values.tax_rate).toFixed(2);
        }

        if (isProductExpire) {
          payload.expiry_date = s_expiry_date;
          payload.start_expiration_notification = s_start_expiration_notification;
        }

        for (let key in values) {
          if (values[key]) {
            payload[key] = values[key];
          }
        }

        if (fileList.length) {
          payload.picture = fileList[0];
        }
        
        if( hasCustomQuantity ){
          // const {
          //   custom_name,
          //   custom_price,
          //   barcode,
          //   custom_quantity,
          // } = values;

          if(this.state.customQuantity.length === 0 ){
            this.setState({ loading: false });
            return Modal.warn({
              title: "Kindly add custom quantity"
            })
          }
        }  

        const formData = transformInToFormObject(payload);

        this.props.addNewProduct(formData).then(res => {
            this.setState({ loading: false });

            if (res && res.status === 200) {
              const { hasCustomQuantity, customQuantity } = this.state;
              if(hasCustomQuantity){
                customQuantity.map(async (custom)=>{
                  const payload = {
                    name: custom.name,
                    price: custom.price,
                    quantity: custom.quantity,
                    barcode: custom.barcode,
                    product_id: res.data.id,
                    merchant_id: res.data.merchant_id
                  }
                  await api.product.addCustomQuantity( payload );
                })
              }
              if (showLowStockNotification) {
                const notificationPayload = {
                  data: {
                    notification_type: values.notification_type,
                    notification_frequency: values.notification_frequency,
                    low_stock_level: values.low_stock_level,
                    product_id: res.data.id,
                    merchant_id: this.props.user.id,
                    active: true,
                  },
                };
                api.HttpClient.post(
                  "/product/stock_notification",
                  notificationPayload
                )
                  .then(res => {
                    if (res.status === 200) {
                      message.success("Product notifications set successfully");
                    }
                  })
                  .catch(err => message.error(err.message));
              }

              form.resetFields();
              this.setState({
                variants: [],
                isTrackProduct: false,
              });
              getAllProducts();
              this.props.updateProducts();

              Modal.success({
                title: strings.youveSuccessfullyAddedANewProduct,
                onOk: () => this.props.closeModal(),
              });
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      });
    };

    handleProductPicture = file => {
      if (file.size > maxFileSize) {
        message.warning(strings.fileTooLargeLessThan4Mb);
        return;
      }
      this.setState(state => {
        return !(state.fileList.length > 0)
          ? { fileList: [...state.fileList, file] }
          : state.fileList;
      });

      return false;
    };

    handleRemoveProductPicture = file => {
      const index = this.state.fileList.indexOf(file);
      this.setState(state => {
        const newFileList = state.fileList.slice();
        newFileList.splice(index, 1);
        return {
          fileList: newFileList,
          imageLoading: false,
        };
      });
    };

    toggleAddCategoryModal = () => {
      this.setState({ showAddCategoryModal: !this.state.showAddCategoryModal });
    };

    displayVariants = () => {
      const { variants, editingVariantIndex } = this.state;

      if (variants.length === 0) return strings.addVariants + "...";
      return variants.map((variant, key) => {
        const isEditing = editingVariantIndex === key;
        return (
          <Badge
            key={key}
            count={variant.quantity}
            style={{
              backgroundColor: "#D90068",
              color: "#fffff",
              marginBottom: "10px",
            }}
          >
            <Tooltip title={`${strings.costPrice}:- ${variant.cost_price}`}>
              <div style={{display: "flex", alignItems: "center", gap:10}}>
                <span
                  className="btn edit-variant-btn"
                  onClick={() => {
                    this.handleEditVariant(variant, key);
                  }}
                  style={{zIndex:2, cursor: "pointer", fontSize: "24px", padding: "0 8px"}}
                  title="Edit variant"
                >
                  ✎
                </span>
                <div className="variant" style={{ backgroundColor: isEditing ? "#e6f7ff" : "transparent", padding: isEditing ? "5px" : "0", borderRadius: "4px" }}>
                  <span>{variant.type}</span>-<span>{variant.value}</span>
                  <span>{variant.price ? `#${variant.price}` : null}</span>
                  <span
                    className="btn delete-variant-btn"
                    onClick={() => {
                      this.handleRemoveVariants(variant.value);
                    }}
                  >
                    x
                  </span>
                </div>
              </div>
            </Tooltip>
          </Badge>
        );
      });
    };

    handleRemoveVariants = value => {
      const { variants } = this.state;
      const result = variants.filter(variant => {
        return variant.value !== value;
      });
      this.setState({
        variants: result,
      });

      // Update Product Quantity to Total Quantity of Variants
      let variantsCopy = [...result];

      const totalVariantQty =
        variantsCopy.length &&
        variantsCopy.reduce(
          (total, variant) => total + Number(variant.quantity),
          0
        );

      totalVariantQty > 0 &&
        this.props.form.setFieldsValue({ quantity: totalVariantQty });
    };

    render() {
      const {
        showModal,
        closeModal,
        form,
        user,
        allLoyaltyPrograms,
        allCategories,
        product_sku,
        uRewardID
      } = this.props;

      const hint = {
        color: "orange",
        fontSize: "13px",
        marginTop: "-8px"
      };

      const { getFieldDecorator } = form;

      const { showAddCategoryModal, shouldProductBePublished } = this.state;

      const isAdmin = user.role_id === 1;

      return (
        <React.Fragment>
          <Modal
            title={strings.addProduct}
            open={showModal}
            okText={strings.cloneProduct}
            cancelText={strings.cancel}
            onCancel={() => {
              this.setState({
                fileList: [],
                isTrackProduct: false,
                showTaxedSelect: false,
              });
              closeModal();
            }}
            className="add-product-modal"
            style={{ top: 20 }}
            onOk={this.handleAddProduct}
            okButtonProps={{ loading: this.state.loading }}
            destroyOnClose
            maskClosable={false}
          >
            <Form layout="vertical">
              <FormItem label={strings.productName}>
                {getFieldDecorator("name", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseEnterProductName,
                    },
                  ],
                })(<Input size="large" />)}
              </FormItem>

              <FormItem label={strings.productDescription}>
                {getFieldDecorator("description")(<Input size="large" />)}
              </FormItem>

              <FormItem label="Product SKU">
                {getFieldDecorator("product_sku", {
                  initialValue: product_sku,
                })(<Input size="large" />)}
              </FormItem>

              <FormItem label={strings.selectProductCategory}>
                {getFieldDecorator("merchant_product_category_id", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseSelectProductCategory,
                    },
                  ],
                })(
                  <Select size="large" onChange={this.onCategoryChange}>
                    <Option value="add-new-category">
                      {strings.addNewCategory}
                    </Option>
                    {allCategories &&
                      allCategories.map(category => (
                        <Option value={category.id} key={category.id}>
                          {category.name}
                        </Option>
                      ))}
                  </Select>
                )}
              </FormItem>

              <FormItem label={strings.selectLoyaltyProgram}>
                {getFieldDecorator("merchant_loyalty_program_id")(
                  <Select size="large" onChange={this.onLoyaltyProgramChange}>
                    <Option key="add-new-program" value={null}>
                      {strings.addNewLoyaltyProgram}
                    </Option>
                    {allLoyaltyPrograms &&
                      allLoyaltyPrograms.map(loyaltyProgram => (
                        <Option
                          value={loyaltyProgram.id}
                          key={loyaltyProgram.id}
                        >
                          {loyaltyProgram.name}
                        </Option>
                      ))}
                  </Select>
                )}
              </FormItem>

              {isAdmin && (
                <FormItem
                  label={`${strings.productCostPrice} ${
                    user.currency ? user.currency : ""
                  }`}
                >
                  {getFieldDecorator("cost_price")(
                    <InputNumber
                      formatter={value =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={value => value.replace(/\bNGN\s?|(,*)/g, "")}
                      size="large"
                      style={{ width: "100%" }}
                    />
                  )}
                </FormItem>
              )}

              <FormItem
                label={`${strings.productSellingPrice} ${
                  user.currency ? user.currency : ""
                }`}
              >
                {getFieldDecorator("price", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseEnterProductSellingPrice,
                    },
                  ],
                })(
                  <InputNumber
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={value => value.replace(/\bNGN\s?|(,*)/g, "")}
                    size="large"
                    style={{ width: "100%" }}
                  />
                )}
              </FormItem>

              <FormItem label={strings.productImage}>
                {getFieldDecorator("picture")(
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Upload
                      // {...this.uploadProps}
                      fileList={this.state.fileList}
                      beforeUpload={this.handleProductPicture}
                      onRemove={this.handleRemoveProductPicture}
                    >
                      <Button>
                        <Icon type="upload" /> {strings.selectProductImage}
                      </Button>
                      {/* <p style={hint}>
                      {user.currency === "NGN"
                        ? <p>This item would be made are available for online orders on your Loystar Shop link <a href={`${process.env.REACT_APP_UREWARDS_BASE_URL}/${uRewardID}`}>{process.env.REACT_APP_UREWARDS_BASE_URL}/{uRewardID}</a></p>
                        : ""}
                    </p> */}
                    </Upload>
                  </div>
                )}
              </FormItem>
              <FormItem label={strings.publish}>
                {getFieldDecorator("publish_to_loystar_shop")(
                  // <Checkbox
                  //   checked={shouldProductBePublished}
                  //   onChange={this.handlePublishProduct}
                  //   style={{scale: "1.5", marginLeft: "0.3rem"}}
                  // />
                  <Switch
                    checked={shouldProductBePublished}
                    onChange={this.handlePublishProduct}
                  />
                )}
              </FormItem>
              <p style={hint}>
                      {user.currency === "NGN"
                        ? <p>This item would be made are available for online orders on your Loystar Shop link - <a href={`${process.env.REACT_APP_UREWARDS_BASE_URL}/${uRewardID}`} target="_blank" rel="noopener">{process.env.REACT_APP_UREWARDS_BASE_URL}/{uRewardID}</a></p>
                        : ""}
                </p>
              <FormItem label={strings.doYouWantToTrackProductStock}>
                {getFieldDecorator("track_inventory")(
                  <Switch
                    onChange={this.handleTrackProduct}
                    checked={this.state.isTrackProduct || this.state.hasVariant}
                  />
                )}
              </FormItem>

              {this.state.isTrackProduct || this.state.hasVariant ? (
                <>
                  <FormItem label={strings.stockUnit}>
                    {getFieldDecorator("unit", {
                      rules: [
                        {
                          required: this.state.isTrackProduct,
                          message: strings.pleaseSelectStockUnit,
                        },
                      ],
                    })(
                      <Select size="large">
                        <Option value="bag">{strings.bag}</Option>
                        <Option value="bottles">{strings.bottle}</Option>
                        <Option value="bunch">{strings.bunch}</Option>
                        <Option value="can">{strings.can}</Option>
                        <Option value="carton">{strings.carton}</Option>
                        <Option value="crate">{strings.crate}</Option>
                        <Option value="cup">{strings.cup}</Option>
                        <Option value="dozen">{strings.dozen}</Option>
                        <Option value="gigabyte">{strings.gigabytes}</Option>
                        <Option value="gram">{strings.gram}</Option>
                        <Option value="kg">{strings.kilogram}</Option>
                        <Option value="litre">{strings.litre}</Option>
                        <Option value="pack">{strings.pack}</Option>
                        <Option value="pair">{strings.pair}</Option>
                        <Option value="pcs">{strings.pieces}</Option>
                        <Option value="plate">{strings.plate}</Option>
                        <Option value="tonne">{strings.tonne}</Option>
                        <Option value="unit">{strings.uNIT}</Option>
                        <Option value="yard">{strings.yard}</Option>
                      </Select>
                    )}
                  </FormItem>

                  <FormItem label={strings.productQuantity}>
                    {getFieldDecorator("quantity", {
                      rules: [
                        {
                          required: this.state.isTrackProduct,
                          message: strings.pleaseEnterProductQuantity,
                        },
                        // {
                        //   min: 1,
                        //   message: "Quantity cannot be negative value",
                        // },
                      ],
                    })(
                      <InputNumber
                        disabled={this.state.hasVariant}
                        size="large"
                        style={{ width: "100%" }}
                        min={0}
                      />
                    )}
                  </FormItem>
                </>
              ) : null}

              <FormItem label={strings.doesProductHaveVariants}>
                {getFieldDecorator("product_variants")(
                  <Switch 
                    onChange={this.handleProductVariants} 
                    checked={this.state.hasVariant}
                  />
                )}
              </FormItem>

              {this.state.hasVariant ? (
                <>
                  <div className="variant-container">
                    {this.displayVariants()}
                  </div>

                  <div style={{ marginTop: "2rem" }} data-variant-form>
                    <div style={{ marginBottom: "10px" }}>
                      {this.state.editingVariant !== null && (
                        <div style={{ 
                          backgroundColor: "#e6f7ff", 
                          padding: "10px", 
                          borderRadius: "4px", 
                          marginBottom: "10px",
                          border: "1px solid #91d5ff"
                        }}>
                          <strong>Editing:</strong> {this.state.editingVariant.type} - {this.state.editingVariant.value}
                        </div>
                      )}
                    </div>
                    <div className="row-wrapper">
                      <FormItem label={strings.type}>
                        {getFieldDecorator("variant_type", {
                          rules: [
                            {
                              required: false,
                              message: strings.pleaseEnterVariantType,
                            },
                          ],
                        })(
                          <VariantKeySelector
                            businessType={this.getVariantPresetKey()}
                            size="large"
                            placeholder="Select or enter variant key"
                          />
                        )}
                      </FormItem>

                      <FormItem label={strings.value}>
                        {getFieldDecorator("variant_value", {
                          rules: [
                            {
                              required: false,
                              message: strings.pleaseEnterVariantValue,
                            },
                          ],
                        })(
                          <VariantValueSelector
                            businessType={this.getVariantPresetKey()}
                            variantKey={this.props.form.getFieldValue("variant_type")}
                            size="large"
                            placeholder="Select or enter variant value"
                          />
                        )}
                      </FormItem>
                    </div>

                    <div className="row-wrapper">
                      <FormItem label={strings.sellingPrice}>
                        {getFieldDecorator("variant_price", {
                          rules: [
                            {
                              required: false,
                              message: strings.pleaseEnterVariantPrice,
                            },
                          ],
                        })(
                          <InputNumber
                            formatter={value =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={value =>
                              value.replace(/\bNGN\s?|(,*)/g, "")
                            }
                            size="large"
                          />
                        )}
                      </FormItem>

                      {isAdmin && (
                        <FormItem label={strings.costPrice}>
                          {getFieldDecorator("variant_cost_price")(
                            <InputNumber
                              formatter={value =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={value =>
                                value.replace(/\bNGN\s?|(,*)/g, "")
                              }
                              size="large"
                            />
                          )}
                        </FormItem>
                      )}
                    </div>

                    <div className="row-wrapper">
                      <FormItem label={strings.quantity}>
                        {getFieldDecorator("variant_quantity", {
                          rules: [
                            {
                              required: false,
                              message: strings.pleaseEnterVariantQuantity,
                            },
                          ],
                        })(<InputNumber size="large" />)}
                      </FormItem>

                      <FormItem
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: "10px",
                        }}
                      >
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={this.addVariant}
                        >
                          {this.state.editingVariant !== null ? "Update Variant" : strings.add}
                        </Button>
                        {this.state.editingVariant !== null && (
                          <Button
                            htmlType="button"
                            onClick={this.handleCancelEditVariant}
                          >
                            {strings.cancel}
                          </Button>
                        )}
                      </FormItem>
                    </div>
                  </div>
                </>
              ) : null}

              <FormItem label={strings.doesProductHaveCustom}>
                {getFieldDecorator("has_custom_qty")(
                  <Switch 
                    onChange={this.handleProductCustom} 
                    checked={this.state.hasCustomQuantity}
                  />
                )}
              </FormItem>

              {this.state.hasCustomQuantity && !this.state.hasVariant ? (
                <>
                  <div style={{ marginTop: "0" }}>
                    <div className="">
                      <h4>Custom quantities:</h4>
                      <ul>{this.displayCustomQuantity()}</ul>
                    </div>
                    <div className="row-wrapper">
                      <FormItem label={strings.customName}>
                        {getFieldDecorator("custom_name", {
                          // rules: [
                          //   {
                          //     required: true,
                          //     message: strings.pleaseEnterCustomName,
                          //   },
                          // ],
                        })(<Input size="large" />)}
                      </FormItem>

                      <FormItem label={strings.customPrice}>
                        {getFieldDecorator("custom_price", {
                          // rules: [
                          //   {
                          //     required: true,
                          //     message: strings.pleaseEnterCustomPrice,
                          //   },
                          // ],
                        })(<InputNumber size="large" />)}
                      </FormItem>
                    </div>

                    <div className="row-wrapper">
                      <FormItem label={"barcode"}>
                          {getFieldDecorator("barcode", {
                            initialValue: product_sku,
                          })(<Input size="large" />)}
                      </FormItem>

                      {/* <FormItem label={"product id"}>
                          {getFieldDecorator("custom_product_id", {
                            rules: [
                              {
                                required: true,
                                message: "Please Enter Product Id",
                              },
                              
                            ],
                          })(<Input size="large" readOnly />)}
                      </FormItem> */}
                    </div>

                    <div className="row-wrapper">
                      <FormItem label={strings.quantity}>
                        {getFieldDecorator("custom_quantity", {
                          // rules: [
                          //   {
                          //     required: false,
                          //     message: strings.pleaseEnterVariantQuantity,
                          //   },
                          // ],
                        })(<InputNumber size="large" />)}
                      </FormItem>

                      <FormItem
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          width: "47%",
                        }}
                      >
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={this.addCustomQuantity}
                        >
                          {strings.add}
                        </Button>
                      </FormItem>
                    </div>
                  </div>
                </>
              ) : null}

              <FormItem label={strings.isThisProductTaxed}>
                {getFieldDecorator("tax")(
                  <Switch onChange={this.handleTaxProduct} />
                )}
              </FormItem>

              {this.state.showTaxedSelect ? (
                <>
                  <FormItem label={strings.selectTaxType}>
                    {getFieldDecorator("tax_type", {
                      rules: [
                        {
                          required: true,
                          message: strings.pleaseSelectTaxType,
                        },
                      ],
                    })(
                      <Select size="large">
                        <Option value="VAT">VAT</Option>
                        <Option value="PROGRESSIVE">
                          {strings.progressive}
                        </Option>
                        <Option value="PROPORTIONAL">
                          {strings.proportional}
                        </Option>
                      </Select>
                    )}
                  </FormItem>

                  <FormItem label={strings.taxRate}>
                    {getFieldDecorator("tax_rate", {
                      rules: [
                        {
                          required: this.state.showTaxedSelect,
                          message: strings.pleaseEnterProductTaxRate,
                        },
                      ],
                    })(<InputNumber size="large" style={{ width: "100%" }} />)}
                  </FormItem>
                </>
              ) : null}

              <FormItem label={strings.setProductExpiryReminder}>
                {getFieldDecorator("isProductExpire")(
                  <Switch
                    onChange={this.handleExpiryDate}
                    checked={this.state.isProductExpire}
                  />
                )}
              </FormItem>
              {this.state.isProductExpire ? (
                <div className="row-wrapper">
                  <FormItem label={strings.productExpiryDate}>
                    <DatePicker
                      size="large"
                      style={{ width: "100%" }}
                      format="YYYY-MM-DD"
                      onChange={(d, dateString) =>
                        this.handleDatepicker(d, dateString, "s_expiry_date")
                      }
                    />
                  </FormItem>
                  <FormItem label={strings.startRemindingFrom}>
                    <DatePicker
                      size="large"
                      style={{ width: "100%" }}
                      format="YYYY-MM-DD"
                      onChange={(d, dateString) =>
                        this.handleDatepicker(
                          d,
                          dateString,
                          "s_start_expiration_notification"
                        )
                      }
                    />
                  </FormItem>
                </div>
              ) : null}

              <FormItem label="Send low stock notifications?">
                {getFieldDecorator("low_stock_notification")(
                  <Switch onChange={this.handleLowStockNotification} />
                )}
              </FormItem>

              {this.state.showLowStockNotification ? (
                <>
                  <div className="row-wrapper">
                    <FormItem label="Select Notification Type">
                      {getFieldDecorator("notification_type", {
                        rules: [
                          {
                            required: true,
                            message: "Please select notification type",
                          },
                        ],
                      })(
                        <Select size="large">
                          <Option value="email">Email only</Option>
                          <Option value="sms">SMS only</Option>
                          <Option value="both">Email and SMS</Option>
                        </Select>
                      )}
                    </FormItem>

                    <FormItem label="Notification Frequency">
                      {getFieldDecorator("notification_frequency", {
                        rules: [
                          {
                            required: this.state.showLowStockNotification,
                            message: "Please select notification frequency",
                          },
                        ],
                      })(
                        <Select size="large">
                          <Option value="once">Once</Option>
                          <Option value="until_restocked">
                            Everyday until restocked
                          </Option>
                        </Select>
                      )}
                    </FormItem>
                  </div>

                  <FormItem label="Low Stock Level">
                    {getFieldDecorator("low_stock_level", {
                      rules: [
                        {
                          required: this.state.showLowStockNotification,
                          message:
                            "Please enter stock level to start notification",
                        },
                      ],
                    })(<InputNumber size="large" style={{ width: "100%" }} />)}
                  </FormItem>
                </>
              ) : null}
              {/* <FormItem label={strings.publish}>
                {getFieldDecorator("publish_to_loystar_shop")(
                  <Checkbox
                    checked={shouldProductBePublished}
                    // defaultChecked={}
                    onChange={this.handlePublishProduct}
                    style={{scale: "1.5", marginLeft: "0.3rem"}}
                  />
                )}
              </FormItem> */}
            </Form>
          </Modal>
          <AddCategoryModal
            toggleModal={this.toggleAddCategoryModal}
            showAddCategoryModal={showAddCategoryModal}
          />
        </React.Fragment>
      );
    }
  }
);

const mapStateToProps = state => ({
  user: state.auth.user,
  allCategories: state.category.allCategories,
  allLoyaltyPrograms: state.loyaltyProgram.allLoyaltyPrograms,
});

export default connect(mapStateToProps, {
  getAllCategories,
  getAllLoyaltyPrograms,
  addNewProduct,
  getAllProducts,
})(CloneProductModal);
